import React from 'react';
import { withNamespaces } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import PayrollFileConfigurationAPI from '../../api/payroll-file-configurations';
import DefaultPayrollFileForm from '../../components/DefaultPayrollFileForm';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import Toast from '../../components/Toast';
import PageContainer from '../../containers/PageContainer';
import { INTERNAL_LINKS } from '../../enum';
import withAuthentication from '../../hocs/withAuthentication';

const CreateCustomPayrollFileView = props => {
  const { t, history, match } = props;

  const queryClient = useQueryClient();

  const createPayrollFileConfigurationMutation = useMutation(
    data =>
      new PayrollFileConfigurationAPI().createPayrollFileConfiguration({
        ...data,
        companyId: match.params.companyId,
        isGlobal: false,
      }),
    {
      onSuccess: responseData => {
        queryClient.invalidateQueries(['fetchPayrollFileConfiguration', match.params.companyId]);
        Toast({
          type: 'success',
          message: t('createPayrollFileConfigurationSuccess'),
        });
        history.replace(
          INTERNAL_LINKS.UPDATE_CUSTOM_PAYROLL_FILE(responseData._id, match.params.companyId),
        );
      },
      onError: () => {
        Toast({
          type: 'error',
          message: t('createPayrollFileConfigurationError'),
        });
      },
    },
  );

  const handleSubmit = payload => {
    createPayrollFileConfigurationMutation.mutate(payload);
  };

  return (
    <PageContainer
      title={
        <PageBreadcrumbs
          items={[
            {
              label: t('Company'),
              onClick: () =>
                history.push(
                  `${INTERNAL_LINKS.SELECT_COMPANY}/${match.params.companyId}?activeTab=payrollFileConfiguration`,
                ),
            },
            { label: t('payrollFileConfiguration') },
          ]}
        />
      }
    >
      <DefaultPayrollFileForm
        t={t}
        onSubmit={handleSubmit}
        loading={createPayrollFileConfigurationMutation.isLoading}
        disabled={createPayrollFileConfigurationMutation.isLoading}
      />
    </PageContainer>
  );
};

export default withNamespaces()(withAuthentication(CreateCustomPayrollFileView));
